<div class="backg"></div>

<app-breadcrumbs
  [segments]="[{ label: breadcrumbLabel, routerLink: '/info_aifa' }]"
></app-breadcrumbs>

<app-static-text 
  [title]="info.title"
  [text]="info.text"
></app-static-text>